import styles from './chip.module.css'

const Chip = ({active, count, children, ...props}) => (
  <button
    className={styles.chip}
    type="button"
    aria-pressed={active}
    {...props}
  >
    {children}
    {count != null && <span className={styles.count}>{count}</span>}
  </button>
)

export default Chip
